export interface SpejdersportShopType {
   id: string,
   name: string
   externalId: string
}

export interface SpejdersportShopPayload {
   ts: number,
   stores: SpejdersportShopType[]
}

export const SpejdersportShopDefault: SpejdersportShopPayload = {
   "ts": 1706696958860, // Latest Timestamp
   "stores": [{
      /** Randers */
      id: '5074de858f9842908eee8709cf8f7265',
      name: 'Spejder Sport Randers',
      externalId: '25',
   },
   {
      /** Tåstrup */
      id: '53101fdce03f4dd7953be938fde5d4d8',
      name: 'Spejder Sport Tåstrup',
      externalId: '06',
   },
   {
      /** Horsens */
      id: '907c321ff4a743d593edfa04f074ac21',
      name: 'Spejder Sport Horsens',
      externalId: '22',
   },
   {
      /** Rødovre */
      id: 'c95414ea93dc47c69d3e768d41f0d15a',
      name: 'Spejder Sport Rødovre',
      externalId: '16',
   },
   {
      /** Amager */
      id: '535a77e3def148aaa623247ba63e8995',
      name: 'Spejder Sport Amager',
      externalId: '20',
   },
   {
      /** Herning */
      id: '72881bb1194d402b966d3c2024e131bf',
      name: 'Spejder Sport Herning',
      externalId: '11',
   },
   {
      /** Frederiksborggade */
      id: '8aaa1b15e87b4d9da3826a7e13c9a7b9',
      name: 'Spejder Sport Frederiksborggade - Patagonia shop-in-shop',
      externalId: '12',
   },
   {
      /** Næstved */
      id: '9b2eb35abcdf4cc6a5563bcc4d9a1a2b',
      name: 'Spejder Sport Næstved',
      externalId: '09',
   },
   {
      /** Esbjerg */
      id: '8c9fb4d0382c4469a7f9fc76df761861',
      name: 'Spejder Sport Esbjerg',
      externalId: '19',
   },
   {
      /** Silkeborg */
      id: '5824819e2b2c4133a32a972a890893a4',
      name: 'Spejder Sport Silkeborg',
      externalId: '24',
   },
   {
      /** Farimagsgade */
      id: 'e8f8bb18d4004a72a690c8af44c515dd',
      name: 'Spejder Sport Nr. Farimagsgade',
      externalId: '01',
   },
   {
      /** Viborg */
      id: '29e22814f95245bc82de5881cf6c7052',
      name: 'Spejder Sport Viborg',
      externalId: '23',
   },
   {
      /** Odense */
      id: '09fdc79dc95242f8bd3b6313f47a9e1d',
      name: 'Spejder Sport Odense - Patagonia shop-in-shop',
      externalId: '03',
   },
   {
      /** Lyngby */
      id: 'cf4650e763eb4fffa3b6fff55dd7958a',
      name: 'Spejder Sport Lyngby',
      externalId: '02',
   },
   {
      /** Aalborg */
      id: 'fb6740cde97249b8a44b51e60e178b28',
      name: 'Spejder Sport Aalborg',
      externalId: '05',
   },
   {
      /** Kolding */
      id: '827ebc60edb34675b4f1415c2bae85d5',
      name: 'Spejder Sport Kolding',
      externalId: '08',
   },
   {
      /** Vejle */
      id: 'a16ac2d874cf468e94700f02534e88d8',
      name: 'Spejder Sport Vejle',
      externalId: '17',
   },
   {
      /** Aarhus */
      id: '9a7b52d063194b1593b6feb9c92101a2',
      name: 'Spejder Sport Aarhus - Patagonia Shop-in-Shop',
      externalId: '04',
   },
   {
      /** Roskilde */
      id: '595fd6b38b694e1595e42bfce0920ff5',
      name: 'Spejder Sport Roskilde',
      externalId: '15',
   },
   {
      /** Rosengårdcentret */
      id: '6e4b33d009f843ec9a5f3b0a4127f3f3',
      name: 'Spejder Sport Rosengårdcentret',
      externalId: '21',
   },
   {
      /** Østerport */
      id: 'f91d5031be824c78b8307f38cbd407f3',
      name: 'Spejder Sport Østerport',
      externalId: '18',
   },
   {
      /** Magasin Du Nord */
      id: 'c655c1eaf01547b6941537ade627dc64',
      name: 'Magasin Du Nord',
      externalId: '110',
   },
   {
      /** Hillerød */
      id: 'b8f0c9cf0cd545fe97cb0584fa93ea48',
      name: 'Spejder Sport Hillerød',
      externalId: '14',
   }]
}

